const state = {
    statistics: {
        userCount: 0,
        dataSourceCount: 0,
        projectCount: 0,
        templateCount: 0,
        scheduleTaskCount: 0,
        onlineUserCount: 0,
        dailyActiveUserCount: 0,
        dailyRequestCount: 0
    }
}
export default state
